import React from "react";
import { Typography } from "../Typography";
import { LabeledDataType } from "./types";

export const LabeledData = ({ label, value }: LabeledDataType) => {
  return (
    <React.Fragment>
      <Typography
        Tag="p"
        size="xs"
        classname="u-spacing-0 u-grey">
        {label}
      </Typography>
      <Typography
        Tag="p"
        size="xs">
        {value}
      </Typography>
    </React.Fragment>
  );
};
